module.exports = __webpack_public_path__ + "media/svg-new/planet-orange-108ccc9e.svg";